import React, { useState, useEffect } from 'react';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = document.querySelector('.nav').offsetHeight;
      const targetPosition = element.offsetTop - navHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      
      setActiveSection(sectionId);
    }
  };

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__container">
        <ul className="nav__menu">
          <li className="nav__item">
            <a 
              href="#home" 
              className={`nav__link ${activeSection === 'home' ? 'nav__link--active' : ''}`}
              onClick={(e) => scrollToSection(e, 'home')}
            >
              Home
            </a>
          </li>
          <li className="nav__item">
            <a 
              href="#experience" 
              className={`nav__link ${activeSection === 'experience' ? 'nav__link--active' : ''}`}
              onClick={(e) => scrollToSection(e, 'experience')}
            >
              Experience
            </a>
          </li>
          <li className="nav__item">
            <a 
              href="#projects" 
              className={`nav__link ${activeSection === 'projects' ? 'nav__link--active' : ''}`}
              onClick={(e) => scrollToSection(e, 'projects')}
            >
              Projects
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
